import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const container: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 1,
};

export const top: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  flex: '0 0 100%',
  gap: 1,
};

export const scrollContent: SxStyle = {
  display: 'flex',
  alignItems: 'flex-start',
  flexDirection: 'column',
  flexGrow: 1,
  position: 'relative',
};

export const actionBox: SxStyleFunc<boolean | undefined> = (show) => ({
  display: show ? 'flex' : 'none',
  flexGrow: 0,
  gap: 1,
});
